import React from "react";
import ModalCreateAccountant from "./ModalCreateAccountant";
import useModal from "../../../hooks/useModal";
import Button from "../../atoms/Button";
import Modal from "../../molecules/Modal";
import { FaUserPlus } from "react-icons/fa";

const CreateAccountant = ({ refetch }) => {
    const { open, close, isOpen } = useModal();

    return(
        <div>
            <Button text={<FaUserPlus size={22} />} bgColor="green" onClick={open} width="w-10"/>
            {isOpen &&
                <Modal title="Crear contador" onClose={close}>
                    <ModalCreateAccountant refetch={refetch} onClose={close} />
                </Modal>
            }
        </div>
    );
};

export default CreateAccountant;